module.exports = __webpack_public_path__ + "static/media/Michelle_Denisse_JimenezOsorio.486c6aa0.png";